export default "__VITE_ASSET__DUDioGwk__"